export interface PatentImageItem {
    type: string
    height: number;
    width: number;
    url: string;
}

export interface PatentImages{
    OFFICIAL_IMAGE: Record<string, PatentImageItem>;
    OFFICIAL_IMAGE_240: Record<string, PatentImageItem>;
}


export interface PatentImageService {
    /**
     * 获取专利描述
     */
    getPatentOfficeImage(payload: {patentId: string}): Promise<PatentImages>;
}

export const PatentImageService = Symbol.for('PatentImageService');
